module.exports = __webpack_public_path__ + "static/media/author-1.0faff056.png";